<template>
    <main class="py-12 px-6 text-center min-h-screen">
        <div v-if="index != null">
            <div class="heading w-full">
                <h1 class="text-green-dark text-3xl sm:text-5xl font-bold sm:leading-10">{{ $t("Documenti Concorso") }}: #{{ index + 1 }}</h1>                
            </div>
            <div class="content w-full sm:w-3/4 text-left bg-white rounded-lg mt-10 m-auto px-4 sm:px-16 py-6 sm:py-10 shadow-md">
                <h4 class="text-green-medium uppercase font-bold">{{ index + 1 }}. {{ documents[index].title }}</h4>
                <table class="table-auto w-full mt-6" v-if="documents[index].links.length">
                    <tbody>
                        <tr v-for="link, i in documents[index].links" class="border-b border-green-light">
                            <td class="text-sm py-2 font-medium">{{ link.label }}</td>
                            <td class="text-sm text-center w-32"><a class="underline" :href="link.url" target="_blank">{{ $t("Scarica") }}<downloadIco class="text-orange ml-2 w-5"/></a></td>
                        </tr>                   
                    </tbody>
                </table>
            </div>

            <div class="mt-12 sm:mt-24">
                <div class="rounded-full p-5 border border-orange text-center inline-block mx-auto cursor-pointer mr-10 sm:mr-32" @click="prev()" v-if="index > 0">
                    <arrowLeftIco class="w-6 text-orange"/>
                </div>
                <div class="rounded-full p-5 bg-orange text-center inline-block mx-auto cursor-pointer" @click="next()" v-if="index + 1 < documents.length">
                    <arrowRightIco class="w-6 text-white"/>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="heading w-full">
                <h1 class="text-green-dark text-3xl sm:text-5xl font-bold sm:leading-10">{{ $t("Documenti Concorso") }}</h1>
            </div>
            <div class="grid sm:grid-cols-2 2xl:grid-cols-3 gap-x-6 mt-4 sm:mt-10 w-full lg:w-2/3 mx-auto">
                <div v-for="doc, i in documents" :key="i" class="content text-center mt-4 sm:mt-10">
                    <div class="bg-white rounded-lg px-4 xl:px-10 py-6 sm:py-10 block w-full shadow-md h-auto sm:h-48 relative cursor-pointer" @click="show(i)">
                        <sup class="text-green-medium uppercase font-bold">{{ i + 1 }}</sup>
                        <h4 class="text-green-dark font-black text-sm px-4">{{ doc.title }}</h4>
                        <arrowRightIco class="w-6 text-orange mt-3 sm:absolute bottom-6"/>
                    </div>
                </div>            
            </div>
        </div>
    </main>
</template>
<script>
import arrowLeftIco from '@/svg/arrow-left.vue'
import arrowRightIco from '@/svg/arrow-right.vue'
import eyeIco from '@/svg/eye.vue'
import downloadIco from '@/svg/download.vue'
import { mapGetters } from 'vuex'
import documentsIT from '@/data/it/docs.json'
import documentsEN from '@/data/en/docs.json'

export default {
	components: {arrowRightIco, arrowLeftIco, eyeIco, downloadIco},
    data() {
        return {
            index: null
        }
    },
    computed: {
        documents() {
            if(this.$i18n.locale == 'it')
                return documentsIT
            else 
                return documentsEN
        }
    },
    methods: {
        show(i) {
            this.index = i
        },
        prev() {
            this.index--
        },
        next() {
            this.index++
        }
    }
}
</script>